module.exports = __webpack_public_path__ + "img/clickbait-dark.72108b39.svg";